import React, { useEffect, useMemo } from "react";
import TitleBarCard from "../title-bar-card";
import CardGoodsRow from "../card-goods-row";
import { wxInit, myInit, goToPageV2 } from "../../../../utils/common";
import { Tabs } from "@xp-design/mobile";
import { getReportCompData, showToast } from "../../utils";
import "./index.less";
import { trackGdp } from "@/utils/gio-report";
import { useUserContext } from "../../routes/home/userContext";
import { getBrowserEnv } from "@/utils/tools";
import { useConfigPage } from "@/hooks/useConfigPage/useConfigPage";

interface Props {
  comp?: unknown;
}

const { isMyApp, isWXApp, isXPApp } = getBrowserEnv();

const UserGoodsCard = (props: Props) => {
  const { comp } = props;
  const { myMemberGoods, userType, userInfo } = useUserContext();
  const { configPageQuery } = useConfigPage();

  const [activeKey, setActiveKey] = React.useState("card");
  const { userCouponList, userChargeCardList } = myMemberGoods || {};
  const couponType = useMemo(
    () =>
      userCouponList?.length && userChargeCardList?.length
        ? "充电券&储值卡"
        : userCouponList?.length
          ? "充电券"
          : "储值卡",
    [userCouponList, userChargeCardList],
  );

  const compClickReport = (action: string) => {
    trackGdp("P11222", "B033", {
      coupon_type: couponType,
      userType,
      versionId: configPageQuery?.data?.versionCode,
      ...getReportCompData(comp),
    });
  };

  /**
   * 跳转到APP/小程序的【充电卡包-充电券】页面，若当前环境是其他浏览器，则提示“请下载小鹏APP查看充电卡券”
   */
  const goToMyCouponPage = () => {
    compClickReport("GO_TO_COUPON");
    if (isXPApp) {
      goToPageV2({
        url: `xiaopeng://charging/card`,
        params: {
          type: "1",
        },
      });
    } else if (isWXApp) {
      wxInit().then((wx) =>
        wx.miniProgram.navigateTo({
          url: "/charging/pages/voucher-list/index?tabIndex=1",
        }),
      );
    } else if (isMyApp) {
      myInit().then((my) =>
        my.navigateTo({ url: "/charging/pages/voucher-list/index?tabIndex=1" }),
      );
    } else {
      showToast("请下载小鹏APP查看充电卡券");
    }
  };

  useEffect(() => {
    trackGdp("P11222", "B032", {
      coupon_type: couponType,
      userType,
      versionId: configPageQuery?.data?.versionCode,
      ...getReportCompData(comp),
    });
  }, []);

  useEffect(() => {
    if (userChargeCardList && userChargeCardList.length) {
      setActiveKey("card");
    } else if (userCouponList && userCouponList.length) {
      setActiveKey("coupon");
    }
  }, [userChargeCardList, userCouponList]);

  if (!userChargeCardList && !userCouponList) return null;
  if (userChargeCardList?.length === 0 && userCouponList?.length === 0) return null;

  return (
    <div
      onScroll={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <TitleBarCard
        title="权益·我的会员产品"
        className="vip-user-goods-card"
        onClickTitle={() => goToMyCouponPage()}
        userLevelInfo={userInfo}
        rightText="我的充电卡券"
        withoutBottomLine={true}
      >
        <div
          className="user-coupon-wrap"
          onScroll={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          {!!userChargeCardList?.length && !!userCouponList?.length && (
            <Tabs
              className="user-goods-tabs"
              activeKey={activeKey}
              onChange={(key) => {
                setActiveKey(key);
              }}
            >
              <Tabs.Tab title="VIP券" key="coupon"></Tabs.Tab>
              <Tabs.Tab title="VIP储值卡" key="card"></Tabs.Tab>
            </Tabs>
          )}
          {userChargeCardList?.length && activeKey === "card" ? (
            <CardGoodsRow
              userCardList={userChargeCardList}
              type={"card"}
              click={() => compClickReport("BUY_MORE")}
            />
          ) : null}
          {userCouponList?.length && activeKey === "coupon" ? (
            <CardGoodsRow
              userCardList={userCouponList}
              type={"coupon"}
              click={() => compClickReport("BUY_MORE")}
            />
          ) : null}
        </div>
      </TitleBarCard>
    </div>
  );
};

export default UserGoodsCard;
